import * as travelServiceText from '../../../constants/plaintext/relocationRequest/travel/travelServiceDetails'
import { CurrentState } from '../../currentState';
import TransfreeDetails from '../../../common/Models/TransfreeDetails';
import Validation from '../../../common/Validation';

//TravelDetailsViewModel.TravelDetails.TravelServices
export function TravelServiceModel(activeCaseID, relocation) {
    const { caseTransfereeDetails, relocationPlanDependantDetails } = relocation;
    const passengers = [TravelDtlPassenger(caseTransfereeDetails)];
    relocationPlanDependantDetails.RelocationDependents.forEach(dependant => {
        passengers.push(TravelDtlPassenger(dependant));
    });
    // sort passengers based on PartyRelatedRoleID
    passengers.sort((a, b) => a.PartyRelatedRoleID - b.PartyRelatedRoleID)

    return {
        RelocationPlanTravelID: 0,
        CaseID: activeCaseID,
        RelocationPlanID: sessionStorage.getItem('RelocationPlanId'),
        // tService.RelocationPlanServiceSubTypeID = 2;
        RelocationPlanServiceSubTypeID: 2,
        DepartureDate: '',
        DepartingTime: '',
        DepartureCity: '',
        ArrivalDate: '',
        ArrivingTime: '',
        ArrivalCity: '',
        TravelTypeID: '',
        TravelTypeDescription: '',
        TravelTypeCode: '',
        ConcurrencyCheck: null,
        Passengers: passengers,
        RelocationPlanServiceStatusID: 1,
        RelocationPlanServiceStatusCode: 'PLNSVDRAFT',
        RelocationPlanServiceStatusDescription: 'Draft',
        RelocationPlanServicePurposeID: 0,
        RelocationPlanServiceConcurrencyCheck: null,
        RelocationPlanServicePurposeDescription: null,
        OrderSubTypeID: 0,
        IsVfmScenarioQuoteService: false,
        CurrentState: CurrentState.Added,
    }
}

//TravelDetailsViewModel.TravelDetails.TravelServices.Passengers
export function TravelDtlPassenger(transfereeDetails) {
    const transfereeInfo = transfereeDetails.Dependant || transfereeDetails;
    return {
        RelocationPlanTravelID: 0,
        FareTypeID: 0,
        FrequentFlyerNumber: transfereeInfo.FrequentFlyerNumber || null,
        ExcessBaggageCount: 0,
        DietaryRequirementTypeID: 12,
        PartyID: transfereeInfo.PartyID,
        PartyRelatedRoleID: Validation.allNumeric(transfereeInfo.PartyRelatedRoleID) ? parseInt(transfereeInfo.PartyRelatedRoleID) : 0,
        PartyRelatedRoleDesc: transfereeInfo.PartyRelatedRoleDesc || null,
        ConcurrencyCheck: null,
        DateOfBirth: transfereeInfo.DateOfBirth,
        GenderTypeID: transfereeInfo.GenderTypeID,
        GenderTypeDescription: null,
        GivenName: transfereeInfo.GivenName,
        FamilyName: transfereeInfo.FamilyName,
        TitleID: transfereeInfo.TitleID,
        CurrentState: CurrentState.Added,
    }
}

export function AlternateContactModel(caseTransfereeDetails) {
    // if (int.Parse(email["AddressUsageTypeID"].ToString()) == 14 
    //  || int.Parse(email["AddressUsageTypeID"].ToString()) == 16)
    const email = TransfreeDetails.getEmailByAddressUsageTypeID(caseTransfereeDetails, 14)
        || TransfreeDetails.getEmailByAddressUsageTypeID(caseTransfereeDetails, 16);
    // if (int.Parse(Phone["AddressUsageTypeID"].ToString()) == 19)
    const phone = TransfreeDetails.getPhoneNumByAddressUsageTypeID(caseTransfereeDetails, 19);
    return {
        AlternateTravelContactID: 0,
        AlternateContactName: '',
        AlternatePhoneNumber: '',
        ContactEmail: email.ElectronicAddress,
        MobilePhone: phone.TelephoneNumber,
        ConcurrencyCheck: null,
        CurrentState: CurrentState.Added,
    }
}

export function TravelDetailsModel(caseId, relocationPlanDependantDetails, caseTransfereeDetails) {
    return {
        RelocationPlanID: sessionStorage.getItem('RelocationPlanId'),
        CaseID: caseId,
        DefenceCategorisationID: relocationPlanDependantDetails.DefenceCategorisationID,
        IsReturnToAssistUplift: false,
        ExpectedReturnDate: '',
        ExpectedReturnToNewLocationDate: '',
        ReturnTravelTypeID: 6,
        AlternateTravelContactID: 0,
        ConcurrencyCheck: null,
        OrderSubTypeID: 0,
        TravelServices: [],
        AlternateContact: AlternateContactModel(caseTransfereeDetails),
        TravelOwnMeans: [],
        CurrentState: CurrentState.Added,
        RelocationPlanPurposeDetails: {
            CaseID: caseId,
            ProductGroupCode: "TRAVEL"
        }
    }
}

export function OMSModel(caseId, relocation) {
    let orderSubTypeID = 0;
    let passengers = [];
    if (relocation) {
        const { caseTransfereeDetails, relocationPlanDependantDetails } = relocation;
        if (relocationPlanDependantDetails && Object.keys(relocationPlanDependantDetails).length > 0) {
            orderSubTypeID = relocationPlanDependantDetails.OrderSubTypeID;
        }
        passengers = [travelOMSPassenger(caseTransfereeDetails)];
        relocationPlanDependantDetails.RelocationDependents.forEach(dependant => {
            passengers.push(travelOMSPassenger(dependant));
        });
        // sort passengers based on PartyRelatedRoleID
        passengers.sort((a, b) => a.PartyRelatedRoleID - b.PartyRelatedRoleID);
    }
    return {
        RelocationPlanTravelOwnMeansID: 0,
        CaseID: caseId,
        RelocationPlanID: parseInt(sessionStorage.getItem('RelocationPlanId')),
        // tService.RelocationPlanServiceSubTypeID = 2;
        RelocationPlanServiceSubTypeID: 2,
        DepartureDate: '',
        DepartingTime: '',
        DepartureLocation: '',
        ArrivalDate: '',
        ArrivingTime: '',
        ArrivalLocation: '',
        // tService.TravelTypeID = 2;
        TravelTypeID: 2,
        ConcurrencyCheck: null,
        TravelOwnMeansPassengers: passengers,
        Vehicles: [travelOMSVehicle()],
        // tService.RelocationPlanServiceStatusID = 1;
        RelocationPlanServiceStatusID: 1,
        RelocationPlanServicePurposeID: 0,
        RelocationPlanServiceConcurrencyCheck: null,
        RelocationPlanServiceStatusDescription: 'Draft',
        RelocationPlanServiceStatusCode: 'PLNSVDRAFT',
        TravelTypeDescription: 'Own Means',
        TravelTypeCode: "OWNMEANS",
        OrderSubTypeID: orderSubTypeID,
        PrivateVehicleCarryingPassenger: false,
        RemovalVehicleCostUnlistedLocation: 0.0,
        CurrentState: CurrentState.Added
    }
}

export function travelService() {
    return travelServiceText.TRAVEL_SERVIDE_INFO;
}

export function travelOMSPassenger(transfereeDetails, travelOMSId) {
    let partyRelatedRoleID = 0, genderTypeID = 0, titleID = 0, partyID = 0, age = 0, familyMemberPartyID = 0;
    let dateOfBirth = '', givenName = '', familyName = '';
    if (transfereeDetails) {
        const transfereeInfo = transfereeDetails.Dependant || transfereeDetails;
        familyMemberPartyID = transfereeDetails.FamilyMemberPartyID || sessionStorage.getItem('caseTransfereeId');
        partyRelatedRoleID = Validation.allNumeric(transfereeInfo.PartyRelatedRoleID) ? parseInt(transfereeInfo.PartyRelatedRoleID) : 0;
        dateOfBirth = transfereeInfo.DateOfBirth;
        genderTypeID = transfereeInfo.GenderTypeID;
        givenName = transfereeInfo.GivenName;
        familyName = transfereeInfo.FamilyName;
        titleID = transfereeInfo.TitleID;
        partyID = transfereeInfo.PartyID;
        age = transfereeInfo.Age;
    }
    return {
        RelocationPlanTravelOwnMeansPassengerID: 0,
        RelocationPlanTravelOwnMeansID: travelOMSId || 0,
        FamilyMemberPartyID: familyMemberPartyID,
        PartyRelatedRoleID: partyRelatedRoleID,
        ConcurrencyCheck: null,
        DateOfBirth: dateOfBirth,
        GenderTypeID: genderTypeID,
        GivenName: givenName,
        FamilyName: familyName,
        TitleID: titleID,
        TitleDesc: null,
        GenderTypeDescription: null,
        PartyID: partyID,
        DependantAllowanceTravelSoleOrFirstOccupant: false,
        DependantTravelAirRequiresIndividualSeat: '',
        CurrentState: CurrentState.Added,
        Age: age
    };
}

export function travelOMSVehicle() {
    return {
        RelocationPlanOwnMeansVehicleID: 0,
        RelocationPlanTravelOwnMeansID: 0,
        Name: '',
        VehicleTypeID: 0,
        ModelName: '',
        ColourName: "",
        Amount: 0.0,
        EngineCapacity: '',
        RegistrationNumber: "",
        IsTowable: '',
        IsDriveable: false,
        IsRegistered: false,
        YearOfManufacture: null,
        Height: 0.0,
        Length: 0.0,
        Width: 0.0,
        Notes: null,
        Make: '',
        EngineTypeID: 2,
        RegistrationStateID: 0,
        VehicleIdentificationNumber: null,
        ConcurrencyCheck: null,
        TowedVehicle: OMSTowedVehicle(),
        RegistrationExpiryDate: '',
        CurrentState: CurrentState.Added
    }
}

export function OMSTowedVehicle() {
    return {
        RelocationPlanOwnMeansVehicleID: 0,
        RelocationPlanTravelOwnMeansID: 0,
        Name: null,
        VehicleTypeID: 0,
        ModelName: '',
        ColourName: '',
        Amount: 0.0,
        EngineCapacity: '',
        RegistrationNumber: '',
        IsTowable: true,
        IsDriveable: false,
        IsRegistered: false,
        YearOfManufacture: null,
        Height: 0,
        Length: 0,
        Width: 0,
        Notes: null,
        Make: '',
        EngineTypeID: 2,
        RegistrationStateID: 0,
        VehicleIdentificationNumber: null,
        ConcurrencyCheck: null,
        RegistrationExpiryDate: '',
        CurrentState: CurrentState.Added,
    }
}